/* global axios */
import ApiClient from '../ApiClient';

class EnterpriseAccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true, enterprise: true });
  }

  checkout() {
    return axios.post(`${this.url}checkout`);
  }

  subscription() {
    return axios.post(`${this.url}subscription`);
  }

  getLimits() {
    return axios.get(`${this.url}limits`);
  }

  toggleDeletion(action) {
    return axios.post(`${this.url}toggle_deletion`, {
      action_type: action,
    });
  }

  createTopupCheckout(credits) {
    return axios.post(`${this.url}topup_checkout`, { credits });
  }

  // Compra/ajuste de add-on recorrente (CAM / canal / usuário) — altera a subscription.
  createAddonCheckout(priceId, quantity) {
    return axios.post(`${this.url}addon_checkout`, {
      price_id: priceId,
      quantity,
    });
  }

  // Lista os add-ons disponíveis com preço atual buscado do Stripe.
  getAddonPrices() {
    return axios.get(`${this.url}addon_prices`);
  }
}

export default new EnterpriseAccountAPI();
